export function PageHeader(props: {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap mb-7">
      <div>
        <h1 className="text-[24px] font-semibold leading-[1.1] tracking-[-0.02em]">
          {props.title}
        </h1>
        {props.subtitle && (
          <p className="text-[13.5px] text-ink-3 mt-1.5 max-w-[640px]">{props.subtitle}</p>
        )}
      </div>
      {props.actions && <div className="flex gap-2 items-center shrink-0">{props.actions}</div>}
    </div>
  );
}
